import axios from 'axios';

export const callApi = async ({ url, method = 'GET', body = null, headers = {}, auth = true }) => {
  if(auth){
     //headers["Authorization"] = getAccessToken();
    headers["Authorization"] = `Bearer ${localStorage.getItem("AccessToken")}`;

  }
  

  try {
    const response = await axios({
      method: method,
      url: url,
      data:body,
      headers:headers,
      withCredentials: true, 
    });

    return {response : response, data: response.data, error: null };
  } catch (error) {
    return {
      response : null,
      data: null,
      error: error.response?.data || error.message || 'API Error',
    };
  }
};
